import React, {useEffect, useState} from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import { scaleQuantile } from 'd3-scale';
import ReactTooltip from 'react-tooltip';
import {Tooltip} from "react-tooltip";
import LinearGradient from "./LinearGradient";
import './heatMap.css';
import INDIA_TOPO_JSON from './indiaData.json';
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import axios from "axios";


//const INDIA_TOPO_JSON = require('./indiaData.json');

const PROJECTION_CONFIG = {
    scale: 1000,
    center: [78.9629, 22.5937] // always in [East Latitude, North Longitude]
};

// Red Variants
const COLOR_RANGE = [
    '#ffedea',
    '#ffcec5',
    '#ffad9f',
    '#ff8a75',
    '#ff5533',
    '#e2492d',
    '#be3d26',
    '#9a311f',
    '#782618'
];

const DEFAULT_COLOR = '#EEE';

const getRandomInt = () => {
    return parseInt(Math.random() * 100);
};

const geographyStyle = {
    default: {
        outline: 'none'
    },
    hover: {
        fill: '#ccc',
        transition: 'all 250ms',
        outline: 'none'
    },
    pressed: {
        outline: 'none'
    }
};
const getHeatMapData = () => {
    return [
        { id: 'AP', state: 'Andhra Pradesh', value: getRandomInt() },
        { id: 'AR', state: 'Arunachal Pradesh', value: getRandomInt() },
        { id: 'AS', state: 'Assam', value: getRandomInt() },
        { id: 'BR', state: 'Bihar', value: getRandomInt() },
        { id: 'CT', state: 'Chhattisgarh', value: getRandomInt() },
        { id: 'GA', state: 'Goa', value: 21 },
        { id: 'GJ', state: 'Gujarat', value: 22 },
        { id: 'HR', state: 'Haryana', value: getRandomInt() },
        { id: 'HP', state: 'Himachal Pradesh', value: 24 },
        { id: 'JH', state: 'Jharkhand', value: 26 },
        { id: 'KA', state: 'Karnataka', value: 27 },
        { id: 'KL', state: 'Kerala', value: getRandomInt() },
        { id: 'MP', state: 'Madhya Pradesh', value: getRandomInt() },
        { id: 'MH', state: 'Maharashtra', value: getRandomInt() },
        { id: 'MN', state: 'Manipur', value: getRandomInt() },
        { id: 'ML', state: 'Meghalaya', value: 59 },
        { id: 'MZ', state: 'Mizoram', value: getRandomInt() },
        { id: 'NL', state: 'Nagaland', value: 59 },
        { id: 'OR', state: 'Odisha', value: 59 },
        { id: 'PB', state: 'Punjab', value: getRandomInt() },
        { id: 'RJ', state: 'Rajasthan', value: getRandomInt() },
        { id: 'SK', state: 'Sikkim', value: getRandomInt() },
        { id: 'TN', state: 'Tamil Nadu', value: getRandomInt() },
        { id: 'TG', state: 'Telangana', value: getRandomInt() },
        { id: 'TR', state: 'Tripura', value: 14 },
        { id: 'UT', state: 'Uttarakhand', value: getRandomInt() },
        { id: 'UP', state: 'Uttar Pradesh', value: 15 },
        { id: 'WB', state: 'West Bengal', value: 17 },
        { id: 'WB', state: 'West Bengal', value: 17 },
        { id: 'AN', state: 'Andaman and Nicobar Islands', value: getRandomInt() },
        { id: 'CH', state: 'Chandigarh', value: getRandomInt() },
        { id: 'DN', state: 'Dadra and Nagar Haveli', value: 19 },
        { id: 'DD', state: 'Daman and Diu', value: 20 },
        { id: 'DL', state: 'Delhi', value: 59 },
        { id: 'JK', state: 'Jammu and Kashmir', value: 25 },
        { id: 'LA', state: 'Ladakh', value: getRandomInt() },
        { id: 'LD', state: 'Lakshadweep', value: getRandomInt() },
        { id: 'PY', state: 'Puducherry', value: getRandomInt() }
    ];
};
function HeatMap() {
    const [tooltipContent, setTooltipContent] = useState('');
    const [data, setData] = useState(getHeatMapData());

    //const [tooltipContent, setTooltipContent] = useState('');
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const [tooltipVisible, setTooltipVisible] = useState(false);


    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";
    let [selectedValue, setSelectedValue] = useState("State")

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    function getLocationDemographicsByState() {
        var url = CROMPTON_ANALYTICS_URL + "v1/user/location/states"
        axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {
            const apiData = res.data;
            const updatedData = getHeatMapData().map(item => {
                const apiItem = apiData.find(d => d.state === item.state);
                return apiItem ? { ...item, value: apiItem.count } : item;
            });
            setData(updatedData);

        }).catch((error) => {
            //console.log(error)
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })

    }

    useEffect(() => {
        getLocationDemographicsByState()
    }, []);

    const gradientData = {
        fromColor: COLOR_RANGE[0],
        toColor: COLOR_RANGE[COLOR_RANGE.length - 1],
        min: 0,
        max: data.reduce((max, item) => (item.value > max ? item.value : max), 0)
    };

    const colorScale = scaleQuantile()
        .domain(data.map(d => d.value))
        .range(COLOR_RANGE);

    const onMouseEnter = (geo, current) => {
        return (event) => {
            const { pageX, pageY } = event;
            setTooltipContent(`${geo.properties.name}: ${current ? current.value : 'No data'}`);
            setTooltipPosition({ x: pageX, y: pageY });
            setTooltipVisible(true);
        };
    };

    const onMouseLeave = () => {
        setTooltipVisible(false);
    };


    return (
        <div className="full-width-height container">
            <h1 className="no-margin center font-bold">INDIA</h1>
            {tooltipVisible && (
                <div
                    className="tooltip"
                    style={{
                        position: 'absolute',
                        top: tooltipPosition.y,
                        left: tooltipPosition.x,
                        backgroundColor: 'white',
                        padding: '5px',
                        border: '1px solid black',
                        borderRadius: '5px',
                        pointerEvents: 'none'
                    }}
                >
                    {tooltipContent}
                </div>
            )}
            <div className="map-container">
                <ComposableMap
                    projectionConfig={PROJECTION_CONFIG}
                    projection="geoMercator"
                    width={680}
                    height={600}
                    data-tip=""
                >
                    <Geographies geography={INDIA_TOPO_JSON}>
                        {({geographies}) =>
                            geographies.map(geo => {
                                //console.log(geo.id);
                                const current = data.find(s => s.id === geo.id);
                                //console.log(current)
                                return (
                                    <Geography
                                        key={geo.rsmKey}
                                        geography={geo}
                                        fill={current ? colorScale(current.value) : DEFAULT_COLOR}
                                        style={geographyStyle}
                                        onMouseEnter={onMouseEnter(geo, current)}
                                        onMouseLeave={onMouseLeave}
                                    />
                                );
                            })
                        }
                    </Geographies>
                </ComposableMap>
            </div>
            <LinearGradient data={gradientData}/>
        </div>

    );
}

export default HeatMap;
